import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Badge } from 'reactstrap';
import moment from 'moment';

const TaskBadge = props => {
  const status = _.get(props, 'type_status.code');
  const assignmentDate = _.get(props, 'assignment.date');

  if (status === 'finished') {
    return <Badge color="complete">Completed</Badge>;
  }

  if (status === 'in_progress') {
    return <Badge color="success">In Progress</Badge>;
  }

  if (assignmentDate && moment().diff(assignmentDate, 'days') > 0) {
    return <Badge color="danger">Overdue</Badge>;
  }

  return null;
};

TaskBadge.propTypes = {
  type_status: PropTypes.shape({
    code: PropTypes.oneOf(['new', 'in_progress', 'finished']),
  }),
  assignment: PropTypes.shape({
    date: PropTypes.string,
  }),
};

export default TaskBadge;
